<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条知识</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增知识</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="知识名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span><br />
            <span>{{ scope.row.no }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="类型" width="130"></el-table-column>
        <el-table-column prop="createdUserName" label="创建人" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="130">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}") }}
            </div>
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operation" label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button type="text" v-preventReClick @click="handleShare(scope.row)" class="margin-left20 color-blue">分享</el-button>
            <el-button type="text" v-if="tableAcl.indexOf('Edit') != -1" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button type="text" v-if="tableAcl.indexOf('Remove') != -1" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <info :show="showInfo" :id="id" @handleClose="closeInfo"></info>
      <select-user :show="showSelectUser" @getData="getSelectUserData" @close="closeSelectUser"></select-user>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { RemoveKnowBases, GetKnowBases, KnowBaseShare } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import Info from "./info";
import SelectUser from "@/components/select-user";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    Info,
    SelectUser,
  },
  data () {
    return {
      GetDatasAction: GetKnowBases,
      RemoveAction: RemoveKnowBases,
      // PrintAction: GetAcceptInStockPrintData,
      editPath: 'know-base-edit',
      // // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // // 新增、编辑的数据
      // form: {},
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,

      showSelectUser: false,
    };
  },
  methods: {
    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // // 获取列表
    // getData () {
    //   GetKnowBases(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // 查看信息
    handleInfo (row) {
      this.id = row.id;
      this.showInfo = true;
      // this.$router.push("/know-base-edit?formMode=0&id=" + row.id);
    },
    closeInfo () {
      this.showInfo = false;
      this.id = 0;
    },
    // // 新建
    // handleAdd () {
    //   this.$router.push("/know-base-edit?formMode=1");
    // },
    // // 编辑
    // handleUpdate (row) {
    //   this.$router.push("/know-base-edit?formMode=1&id=" + row.id);
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // // 删除部门
    // handleDelete (row) {
    //   const ids = row && row.id ? [row.id] : this.ids;

    //   this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
    //     type: "warning",
    //   })
    //     .then(() => {
    //       return RemoveKnowBases({ ids });
    //     })
    //     .then(() => {
    //       this.$my_message(`操作成功！`, "success");
    //       this.getData();
    //     })
    //     .catch(() => { });
    // },
    // // 重置
    // reset () {
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    //   this.ids = []
    //   this.multipleSelection = []
    //   this.multiple = true;

    //   if (this.$refs.multipleTable) {
    //     this.$refs.multipleTable.clearSelection()
    //   }
    //   this.getData();
    // },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },

    handleShare (row) {
      this.showSelectUser = true;
    },
    getSelectUserData (data) {
      // console.log(data, 'getSelectUserData')
      let ids = data ? data.map((e) => e.id) : [];
      // save role user
      KnowBaseShare({ ids: ids.join(",") }).then((res) => {
        window.console.log(res);
      });
    },
    closeSelectUser () {
      this.showSelectUser = false;
    },
  },
  mounted () {
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>
